import {Injectable} from '@angular/core';
import {UserInteractor} from '../../interactors/user.interactor';
import {LoanApplicationFlowStep} from './loan-application-flow.step';

@Injectable()
export abstract class PostLoginLoanApplicationFlowStep extends LoanApplicationFlowStep {
    protected readonly userInteractor: UserInteractor;

    constructor(userInteractor: UserInteractor) {
        super();
        this.userInteractor = userInteractor;
    }

    async isComplete(): Promise<boolean> {
        return await this.isUserLoggedIn() && await this.isStepComplete();
    }

    public abstract isStepComplete(): Promise<boolean>;

    private async isUserLoggedIn(): Promise<boolean> {
        return !!await this.userInteractor.getUserId();
    }
}